import { render, staticRenderFns } from "./ticketType.vue?vue&type=template&id=10acc8c2&scoped=true"
import script from "./ticketType.vue?vue&type=script&lang=js"
export * from "./ticketType.vue?vue&type=script&lang=js"
import style0 from "./ticketType.vue?vue&type=style&index=0&id=10acc8c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10acc8c2",
  null
  
)

export default component.exports